<template>
  <header class="header container">
    <div class="overlay" @click="hideNav"></div>
    <nav class="nav" v-bind:class="{ 'nav-collapse': navVisible }" v-if="currentUser">
      <ul class="navigation">
        <li>
          <router-link to="/home" @click="hideNav">Home</router-link>
        </li>
        <li>
          <router-link to="/profiles" @click="hideNav">Profiles</router-link>
        </li>
        <li>
          <router-link to="/orders" @click="hideNav">Order View</router-link>
        </li>
        <li>
          <router-link to="/admin" @click="hideNav">Admin</router-link>
        </li>
        <li>
          <a href="#" @click="signOut">Sign Out</a>
        </li>
      </ul>
    </nav>
    <div class="d-flex justify-content-between align-items-center h-100">
      <a href="#" class="menu-toggle" @click="toggleNav" v-bind:class="{ 'active-menu-toggle': activeMenuToggle }" v-if="currentUser"><span></span></a>
      <router-link to="/home" class="site-name">
        <img src="../assets/logo.svg" alt="Aimé Leon Dore" />
      </router-link>
      <router-link to="/create-customer"><i class="icon icon--plus"  v-if="currentUser"></i></router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    toggleNav(e) {
      e.preventDefault();

      this.activeMenuToggle = !this.activeMenuToggle;
      this.navVisible = !this.navVisible;
      document.body.classList.toggle('menu-open');
    },
    hideNav(e) {
      e.preventDefault();

      this.activeMenuToggle = false;
      this.navVisible = false;
      document.body.classList.remove('menu-open');
    },
    signOut(e) {
      e.preventDefault();

      this.auth0Client.logout({returnTo: `${window.location.origin}/auth/logged-out`})
    }
  },
  data() {
    return {
      activeMenuToggle: false,
      navVisible: false
    }
  }
}
</script>
